// extracted by mini-css-extract-plugin
export default {"awards":"awards__N2FiN","awardsList":"awardsList__MGI2M","award":"award__NDUxM","toolTip":"toolTip__YmNjY"};